import { useState, MouseEventHandler } from 'react';
import { useStore } from '@ui/hooks/useStore';
import getLiElementId from '@utils/getLiElementId';
import { IState } from './IState';
import { checkboxClickHandler } from '@ui/components/Checkbox/checkbox-click-handler';

const useShareDeviceSettings = () => {
    const { devices, groups, user, app, lang } = useStore();
    const initState: IState = {
        selectedDevices: [],
        visibleList: {},
    };
    const [state, setState] = useState(initState);

    const handleGroupClick: MouseEventHandler<HTMLLIElement> = (e) => {
        app.resetDemoModeError();
        const target = e.target as HTMLLIElement;
        setState((prev) => {
            const id = getLiElementId(target);
            if (id) {
                const visibleList = { ...prev.visibleList };
                visibleList[id] = !visibleList[id];
                return { ...prev, visibleList };
            } else return prev;
        });
    };
    const handleDeviceClick: MouseEventHandler<HTMLElement> = (e) => {
        e.preventDefault();
        e.stopPropagation();
        app.resetDemoModeError();
        const target = e.target as HTMLElement;
        const imei = getLiElementId(target);
        handleDeviceSelect(imei);
    };
    const handleDeviceSelect: checkboxClickHandler = (imei) => {
        if (!imei) return;
        else if (state.selectedDevices.includes(imei)) {
            setState((prev) => {
                const result = prev.selectedDevices.filter(
                    (val) => val !== imei,
                );
                return {
                    ...prev,
                    selectedDevices: result,
                };
            });
        } else {
            setState((prev) => {
                const result = [...prev.selectedDevices, imei];
                return {
                    ...prev,
                    selectedDevices: result,
                };
            });
        }
    };
    const handleShareClick = () => {
        app.resetDemoModeError();
        if (!app.demoMode) {
            const { selectedDevices } = state;
            if (selectedDevices.length > 0) {
                devices.shareDeviceSettings(
                    selectedDevices.map((imei) => ({ imei })) as any[],
                );
            }
        } else app.setDemoModeError();
    };
    const handlers = {
        handleGroupClick,
        handleDeviceClick,
        handleDeviceSelect,
        handleShareClick,
    };

    return {
        devices,
        groups,
        user,
        app,
        lang,
        state,
        handlers,
    };
};

export default useShareDeviceSettings;
